var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      ref: _vm.sectionRefId,
      staticClass: "section tabs-carousel-swiper theme--white",
      attrs: {
        "aria-label": _vm.isMobile ? false : _vm.carouselData.sectionLabel,
        "aria-roledescription": _vm.isMobile ? false : "carousel",
      },
    },
    [
      _c(
        "div",
        { staticClass: "tabs-carousel-swiper__container-mobile" },
        _vm._l(_vm.slides, function (slide, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "tabs-carousel-swiper__tab",
              attrs: { id: `tab-carousel-slide-${slide.id}` },
            },
            [
              _c("div", { staticClass: "tabs-carousel-swiper__title" }, [
                _vm._v("\n        " + _vm._s(slide.title) + "\n      "),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tabs-carousel-swiper__content-box",
                  attrs: { id: `tab-carousel-panel-${slide.id}` },
                },
                [
                  _c(
                    "div",
                    { staticClass: "background background--size-contain" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "media media--picture media--size-contain",
                        },
                        [
                          slide.background
                            ? _c(
                                "picture",
                                {
                                  staticClass: "picture picture--size-contain",
                                },
                                [
                                  slide.background.largeMobileSrc
                                    ? _c("source", {
                                        attrs: {
                                          srcset:
                                            slide.background.largeMobileSrc,
                                          media: `(min-width: 576px)`,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src: slide.background.src,
                                      alt: slide.background.alt,
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "background__dimmer" }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tabs-carousel-swiper__content-container" },
                    [
                      _c(
                        "div",
                        { staticClass: "tabs-carousel-swiper__description" },
                        [
                          _c("div", {
                            staticClass: "wysiwyg",
                            domProps: { innerHTML: _vm._s(slide.description) },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      slide.button
                        ? _c(
                            "div",
                            { staticClass: "tabs-carousel-swiper__cta" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "btn",
                                  class: [
                                    slide.button.style
                                      ? `btn--${slide.button.style}`
                                      : "",
                                  ],
                                  attrs: {
                                    href: slide.button.href,
                                    target: slide.button.target
                                      ? slide.button.target
                                      : null,
                                  },
                                },
                                [
                                  _c("span", { staticClass: "btn__content" }, [
                                    _c("span", { staticClass: "btn__text" }, [
                                      _vm._v(_vm._s(slide.button.text)),
                                    ]),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tabs-carousel-swiper__container" }, [
        _c("div", { staticClass: "swiper mySwiper" }, [
          _c(
            "div",
            { staticClass: "swiper-wrapper" },
            _vm._l(_vm.slides, function (slide, index) {
              return _c("div", { key: index, staticClass: "swiper-slide" }, [
                _c(
                  "div",
                  {
                    staticClass: "background background--size-contain",
                    class: {
                      "background--active": slide.active,
                      "background--prevactive": slide.prevActive,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "media media--picture media--size-contain",
                      },
                      [
                        slide.background
                          ? _c(
                              "picture",
                              { staticClass: "picture picture--size-contain" },
                              [
                                slide.background.desktopSrc
                                  ? _c("source", {
                                      attrs: {
                                        srcset: slide.background.desktopSrc,
                                        media: `(min-width: 992px)`,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                slide.background.tabletSrc
                                  ? _c("source", {
                                      attrs: {
                                        srcset: slide.background.tabletSrc,
                                        media: `(min-width: 768px)`,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                slide.background.largeMobileSrc
                                  ? _c("source", {
                                      attrs: {
                                        srcset: slide.background.largeMobileSrc,
                                        media: `(min-width: 576px)`,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("img", {
                                  attrs: {
                                    src: slide.background.src,
                                    alt: slide.background.alt,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "background__dimmer" }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tabs-carousel-swiper__content-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "tabs-carousel-swiper__content" },
                      [
                        _c(
                          "div",
                          { staticClass: "tabs-carousel-swiper__description" },
                          [
                            _c("div", {
                              staticClass: "wysiwyg",
                              domProps: {
                                innerHTML: _vm._s(slide.description),
                              },
                            }),
                            _vm._v(" "),
                            slide.button
                              ? _c(
                                  "div",
                                  { staticClass: "tabs-carousel-swiper__cta" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn",
                                        class: [
                                          slide.button.style
                                            ? `btn--${slide.button.style}`
                                            : "",
                                        ],
                                        attrs: {
                                          href: slide.button.href,
                                          target: slide.button.target
                                            ? slide.button.target
                                            : null,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "btn__content" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "btn__text" },
                                              [
                                                _vm._v(
                                                  _vm._s(slide.button.text)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-button-next" }),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-button-prev" }),
          _vm._v(" "),
          _c("div", { staticClass: "swiper-pagination" }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "swiperThumbs",
            staticClass: "swiper SwiperThumbs",
            attrs: { thumbsSlider: "" },
          },
          [
            _c(
              "div",
              { staticClass: "swiper-wrapper tabs-carousel-swiper__wrapper" },
              _vm._l(_vm.slides, function (slide, index) {
                return _c(
                  "div",
                  {
                    key: [index + " thumb"],
                    staticClass: "swiper-slide tabs-carousel-swiper__thumb",
                  },
                  [
                    _c("div", { staticClass: "tabs-carousel-swiper__title" }, [
                      _vm._v(
                        "\n            " + _vm._s(slide.title) + "\n          "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }